import React from 'react'
import MainRoutes from '@routes/Main.route'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import useProductionSSOValidator from '@hooks/useProductionSSOValidator.hook'

const App: React.FC = () => {
    useProductionSSOValidator()
    return (
        <div style={{ marginTop: '60px' }}>
            {process.env.NODE_ENV === 'development' ? (
                <BrowserRouter>
                    <MainRoutes />
                </BrowserRouter>
            ) : (
                <HashRouter>
                    <MainRoutes />
                </HashRouter>
            )}
        </div>
    )
}

export default App
